<template>
    <div>
        <div class="topBox">
            <div class="headerBox clearfix">
                <img class="fl logoImg" src="~@/assets/home/logon.png" @click="home" alt="">
                <img class="fl logoM" src="~@/assets/home/logoM.png"  @click="home" alt="">
                <img class="fr menuImg" src="~@/assets/home/menu.png" @click="openMenu" alt="">
            </div>
            <div class="bannerBoxs">
                <img class="bannerImg" src="~@/assets/home/title.png" alt="">
                <div class="searchBox">
                    <el-input placeholder="请输入关键词搜索" prefix-icon="el-icon-search" v-model="title" @change="searchData">
                        <el-button type="primary" slot="append" icon="el-icon-search" @click="searchData"></el-button>
                    </el-input>
                </div>
            </div>
        </div>
        <el-drawer :visible.sync="drawerVisible" direction="rtl" :with-header="false" size="50%">
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo">
				<div v-for="(item,index) in pathList" :key="index">
					<el-menu-item :index="item.souy" v-if="!item.child" @click="handleSelect(item.path,item.type)">{{item.name}}</el-menu-item>
					<el-submenu v-if="item.child" :index="item.souy">
						<template slot="title">{{item.name}}</template>
						<el-menu-item :index="itemd.souy" v-for="(itemd,indexd) in item.child" :key="indexd" @click="handleSelect(itemd.path,itemd.type)">{{itemd.name}}</el-menu-item>
					</el-submenu>
				</div>
			</el-menu>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            title:'',
            drawerVisible:false,
            activeIndex:'',
            pathList:[
                {
					name:"首页",
					path:'/index',
					souy:'1',
                    type:1
				},
                {
					name:"党建园地",
					path:'/partyBuild',
					souy:'2',
                    child:[
                        {
							name:'党建文件',
							path:'/partyBuild?type=102101',
							souy:'2-1',
                            type:1
						},
                        {
							name:'党建活动',
							path:'/partyBuild?type=102102',
							souy:'2-2',
                            type:1
						},
                    ]
				},
                {
					name:"协会概况",
					path:'/association',
					souy:'3',
                    child:[
                        {
							name:'协会简介',
							path:'/association/Intro',
							souy:'3-1',
                            type:1
						},
                        {
							name:'协会章程',
							path:'/association/Article',
							souy:'3-2',
                            type:1
						},
                        {
							name:'组织架构',
							path:'/association/Team',
							souy:'3-3',
                            type:1
						},
                        {
							name:'理事会成员',
							path:'/association/Member',
							souy:'3-4',
                            type:1
						},
                    ]
				},
                {
					name:"通知资讯",
					path:'/notice',
					souy:'4',
                    child:[
                        {
							name:'通知公告',
							path:'/notice?type=106101',
							souy:'4-1',
                            type:1
						},
                        {
							name:'协会工作',
							path:'/notice?type=106102',
							souy:'4-2',
                            type:1
						},
                        {
							name:'行业动态',
							path:'/notice?type=106103',
							souy:'4-3',
                            type:1
						},
                    ]
				},
                {
					name:"服务平台",
					path:'/service',
					souy:'5',
                    child:[
                        {
							name:'会员风采',
							path:'/service?type=106104',
							souy:'5-1',
                            type:1
						},
                        {
							name:'会员登录',
							path:'http://member.hbaec.com/Jzxh/Login.aspx',
							souy:'5-2',
                            type:2
						},
                        {
							name:'入会申请',
							path:'http://member.hbaec.com/Jzxh/Web/Dw/DwRegister.aspx',
							souy:'5-3',
                            type:2
						},
                    ]
				},
                {
					name:"业务办理",
					path:'/service',
					souy:'6',
                    child:[
                        {
							name:'咨询单位备案',
							path:'https://new.tzxm.gov.cn/',
							souy:'6-1',
                            type:2
						},
                        {
							name:'资信评价系统',
							path:'https://zhywglxt.cnaec.com.cn/#/consultant_login?redirect=%2F',
							souy:'6-2',
                            type:2
						},
                        {
							name:'优秀成果申报',
							path:'http://27.128.238.131:10035/user/login',
							souy:'6-3',
                            type:2
						},
                        {
							name:'执业检查系统',
							path:'http://27.128.238.131:10025/zyjc/classfiy',
							souy:'6-4',
                            type:2
						},
                        {
							name:'咨询专家库',
							path:'http://27.128.238.131:10045/',
							souy:'6-5',
                            type:2
						},
                    ]
				},
                {
					name:"行业自律",
					path:'/industrySelf',
					souy:'7',
                    type:1
				},
                {
					name:"政策法规",
					path:'/policyRegulate',
					souy:'8',
                    type:1
				},
                {
					name:"联系我们",
					path:'/linkUs',
					souy:'9',
                    type:1
				},
            ]
        };
    },
    watch: {
        $route: {
            handler(value){
                // 初始化activeIndex
                let path = value.path.split('/')
                var list= this.pathList
                for(var i=0;i<list.length;i++){
					if(list[i].path.indexOf(path[1])!=-1){
						if(!list[i].child){
							this.activeIndex = list[i].souy
						}
						if(list[i].child){
							var item = list[i].child
							for(var j=0;j<item.length;j++){
								if(item[j].path.indexOf(path[1])!=-1){
									if(this.$route.query.type==106101){
										this.activeIndex='5-1' 
									}else if(this.$route.query.type==106102){
										this.activeIndex='5-2' 
									}else if(this.$route.query.type==106103){
										this.activeIndex='5-2' 
									}else if(this.$route.query.type==102101){
										this.activeIndex='2-1' 
									}else if(this.$route.query.type==102102){
										this.activeIndex='2-2' 
									}else{
										this.activeIndex = item[j].souy
									}
								}
							}
						}
					}
				}
            },
            immediate: true
        }
    },
    mounted(){
        let path = this.$route.path.split('/')
        var list= this.pathList
        for(var i=0;i<list.length;i++){
            if(list[i].path.indexOf(path[1])!=-1){
                if(!list[i].child){
                    this.activeIndex = list[i].souy
                }
                if(list[i].child){
                    var item = list[i].child
                    for(var j=0;j<item.length;j++){
                        if(item[j].path.indexOf(path[1])!=-1){
                            if(this.$route.query.type==106101){
                                this.activeIndex='5-1' 
                            }else if(this.$route.query.type==106102){
                                this.activeIndex='5-2' 
                            }else if(this.$route.query.type==106103){
                                this.activeIndex='5-2' 
                            }else if(this.$route.query.type==102101){
                                this.activeIndex='2-1' 
                            }else if(this.$route.query.type==102102){
                                this.activeIndex='2-2' 
                            }else{
                                this.activeIndex = item[j].souy
                            }
                        }
                    }
                }
            }
        }
       
    },
    methods: {
        // 导航切换
        handleSelect(keyPath,type) {
            if(type==2){ //跳转网站外部链接
                window.open(keyPath,'_blank')
            }else{
                this.$router.push({
                    path:keyPath
                })
                this.drawerVisible = false
            }
        },
         // 打开菜单
		openMenu(){
			this.drawerVisible = true
		},
        // 回到首页
        home(){
            this.$router.push({
                path:'/'
            })
        },
        //查询搜索结果
        searchData(){
            if(!this.title){
                this.$message.info('请填写关键字')
                return
            }
            this.$router.push({
                path:'/new?title='+this.title
            })
           setTimeout(()=>{
            this.title=''
           },10)
        }
    }
}
</script>

<style lang="less" scoped>
    .topBox{
        width: 100%;
        height: 240px;
        background: url('../assets/home/bannernew.png') no-repeat;
        background-size: cover;
    }
    .headerBox{
        width: 100%;
        height: 60px;
        background-color: rgba(255,255,255,.6);
    }
    .logoImg{
        width: 50px;
        height: 50px;
        margin-top: 5px;
        margin-left: 5px;
    }
    .logoM{
        width: calc(100% - 180px);
        margin-top: 12px;
    }
    .menuImg{
        width: 30px;
        margin-top: 15px;
        margin-right: 10px;
    }
    .bannerImg{
        display: block;
        width: 90%;
        margin:0 auto;
        margin-top: 50px;
    }
    .searchBox{
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .searchBox .el-input-group{
        width: 100%;
        height: 40px;
    }
    .searchBox .el-input__inner{
        height: 40px !important;
    }
   .searchBox .el-input-group__append button.el-button{
        color: #409EFF;
    }
</style>